export const URLS = {
  WHATSAPP_SUPPORT_ENKO: 'https://api.whatsapp.com/send?phone=525548868078&text=%C2%A1Hola,%20ENKO!%20',
  WHATSAPP_SUPPORT_COPPEL: 'https://api.whatsapp.com/send?phone=525549049447&text=%C2%A1Hola,%20Coppel!%20',
  COPPEL_PENSION: 'https://bit.ly/3wfjF7T',
  COPPEL_PLATFORM: 'https://www.coppel.com/blog/sala-de-prensa/fundacion-coppel-recibe-reconocimiento-empresas-excepcionales-por-su-apoyo-a-microempresarios-slp/?utm_source=linkedin.com&utm_medium=referral&utm_campaign=blog_reconocimientomicroempresarios',
  COPPEL_FRONT: 'https://www.coppelemprende.com'
}
